import { useContext, useEffect, useMemo } from 'react';
import { getAvailableScenarioColumns } from 'utils/getRecommendationTableColumns';
import { CustomTablePriceSimulationInput } from '../PriceSimulator/SimulationList/SimulationList';
import dayjs from 'dayjs';
import { UserContext } from 'contexts/ConfigContext';
import { sendNotification } from 'utils/helperMethods';

type LinkPricingSimulatorProps = {
    selectedSimulationKey: any[];
    setSelectedSimulationKeys: Function;
    allScenariosData: any[];
    isEditMode?: boolean;
};

const LinkPricingSimulator = ({
    selectedSimulationKey,
    setSelectedSimulationKeys,
    allScenariosData,
    isEditMode = false,
}: LinkPricingSimulatorProps) => {
    const { appConfig } = useContext(UserContext);

    const scenarioData = allScenariosData?.map((s: any) => {
        return {
            Scenario: s.Scenario,
            User: s['User Name'],
            Date: dayjs(s['Date']).format(appConfig?.commonConfig?.dateFormatAlt),
            'Scenario ID': s.scenarioId,
            key: s.scenarioId,
        };
    });

    useEffect(() => {
        // reset selected key on new Plan
        if (!isEditMode) setSelectedSimulationKeys([]);
    }, [isEditMode]);

    const memoisedLinkSimulatorColumns = useMemo(() => {
        const columns = getAvailableScenarioColumns(scenarioData);
        return columns;
    }, [scenarioData]);

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        if (newSelectedRowKeys.length > 1) {
            sendNotification('error', 'You can at most link one pricing scenario');
            return;
        }
        setSelectedSimulationKeys(newSelectedRowKeys);
    };

    const rowSelection: any = {
        selectedRowKeys: selectedSimulationKey,
        onChange: onSelectChange,
        type: 'checkbox',
        hideSelectAll: true,
    };

    return (
        <div>
            {!isEditMode && <p className="font-xs font-bold mb-1 mt-2">Link Pricing scenario</p>}
            <CustomTablePriceSimulationInput
                columns={memoisedLinkSimulatorColumns}
                dataSource={scenarioData || []}
                rowSelection={rowSelection}
                pagination={false}
                scroll={{ x: '100%', y: 300 }}
            />
        </div>
    );
};

export default LinkPricingSimulator;
